export default {
    created() {
        window.scrollTo(0,0)
    }
}